import { decoratedCa } from 'shared/mf-infrastructure/utils/analytics';

interface ITrackRulerCloseParams {
  objectType: string | null;
  blockType: string;
  profile: string | null;
}

export function trackRulerClose({ objectType, blockType, profile }: ITrackRulerCloseParams) {
  decoratedCa('eventSite', {
    action: 'close_sopr',
    category: 'Infrastructure',
    label: 'ruler',
    name: 'oldevent',
    page: {
      extra: {
        profile,
        object_type: objectType,
        block_type: blockType,
      },
    },
    useLastProducts: true,
  });
}
